var _style, _path, _path2, _line, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVacuumCleaner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12,9L12,9c-1.3,5.9-1.3,12.1,0,18l0,0h8l0,0c1.3-5.9,1.3-12.1,0-18l0,0H12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.4,26c0.9,0,1.8,0.6,1.9,1.3L23,31H9l0.7-3.7c0.2-0.8,1-1.3,1.9-1.3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 16,
    y1: 1,
    x2: 16,
    y2: 9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,14c-0.1,0-0.3,0-0.4-0.1c-0.1-0.1-0.2-0.1-0.3-0.2C15.1,13.5,15,13.3,15,13c0-0.3,0.1-0.5,0.3-0.7 c0.1-0.1,0.2-0.2,0.3-0.2c0.4-0.2,0.8-0.1,1.1,0.2c0.2,0.2,0.3,0.4,0.3,0.7c0,0.1,0,0.1,0,0.2c0,0.1,0,0.1-0.1,0.2 c0,0.1-0.1,0.1-0.1,0.2c0,0-0.1,0.1-0.1,0.1C16.5,13.9,16.3,14,16,14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacuumCleaner);
export default __webpack_public_path__ + "static/media/vacuum-cleaner.ec331de51391f05211a6249daeb139ac.svg";
export { ForwardRef as ReactComponent };